export default {"src":"/_next/static/media/FooterLogo.59b84e98.svg","height":88,"width":160,"blurWidth":0,"blurHeight":0};